import React from "react";
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";
import { convertCryptoToUSD } from '../../../../utils/formatPriceNft';

/**
 * Tr Component
 * Table row for displaying individual background price records
 */
export default function Tr({
  id,
  color,
  rank,
  price,
  cryptoPrice,
  onEdit,
  onDelete,
  isAllowedToEditOrDelete
}) {

  /**
     * Handle formatted price
     */
  const priceInUSD = convertCryptoToUSD(price, cryptoPrice);

  /**
   * Handle edit click
   */
  const handleEdit = (e) => {
    if (isAllowedToEditOrDelete) {
      onEdit({ background_price_id: id, rank, price });
    } else {
      e.preventDefault();
    }
  };

  /**
   * Handle delete click
   */
  const handleDelete = (e) => {
    if (isAllowedToEditOrDelete) {
      onDelete({ background_price_id: id, rank, price });
    } else {
      e.preventDefault();
    }
  };

  return (
    <tr>
      <td className="col-numeric-date">
        <div
          className="color-box"
          style={{ backgroundColor: color, margin: "auto" }}
          title={color}
        />
      </td>
      <td className="col-numeric-date">{rank}</td>
      <td className="col-numeric-date">{price}</td>
      <td className="col-numeric-date">{priceInUSD} USD </td>
      <td className="col-options">
        <button
          type="button"
          onClick={handleEdit}
          disabled={!isAllowedToEditOrDelete}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed",
          }}
          aria-label="Edit background price"
        >
          <img className="edit-delete-icons" src={edit_logo} alt="Edit" />
        </button>
        &nbsp;
        <button
          type="button"
          onClick={handleDelete}
          disabled={!isAllowedToEditOrDelete}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed",
          }}
          aria-label="Delete background price"
        >
          <img className="edit-delete-icons ms-3" src={tash_logo} alt="Delete" />
        </button>
      </td>
    </tr>
  );
}